import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LeaveStages } from '@core/enums/leave-stages.enum';
import { CaseDetails } from '@core/models';
import { LayoutService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-calendar-requirements-warning',
    templateUrl: './calendar-requirements-warning.component.html',
    styleUrls: ['./calendar-requirements-warning.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarRequirementsWarningComponent implements OnInit {
  static readonly componentName = 'CalendarRequirementsWarningComponent';
  
  public leaveStages = LeaveStages;
  public caseDetails: CaseDetails;
  public sysText: any;

  public position = position;
  public onDragEnded = onDragEnded;

  constructor (
    @Inject(MAT_DIALOG_DATA)
    public data: { caseDetails: CaseDetails; sysText: any },

    private layoutService: LayoutService,
    private dialogRef: MatDialogRef<CalendarRequirementsWarningComponent>
  ) { }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();

    this.caseDetails = this.data.caseDetails;
    this.sysText = this.data.sysText;
  }

  public isMobile$: Observable<boolean>;

  public close(): void {
    this.dialogRef.close();
  }
}
